import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { UserService } from "@teammood/shared/util/user";
import { Router } from "@angular/router";

@Component({
    selector: "user-home",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    template: "",
})
export class UserHomeComponent implements OnInit {

    constructor(private userService: UserService, private router: Router) {
    }

    ngOnInit(): void {
        this.userService.get().then(async user => {
            if (user.home?.view) {
                await this.router.navigateByUrl(user.home?.view);
            } else {
                await this.router.navigateByUrl('/setup/account');
            }
        });
    }
}